import { computed, toRaw } from 'vue';
import store from '@/study-search/store';
import { ParameterType } from '@/study-search/enums';
import EventsSender from '../../../../infrastructure/events/EventsSender';
import { PortalType } from '@studyportals/domain-client';
import { subdisciplineGetParentId } from '@studyportals/static-domain-data/disciplines/discipline-get-parent-discipline';

export default class NoResults {

	public readonly dataIdentifier = 'search-recommendations';

	public selectedParentDiscipline = computed((): string => {
		const selectedDiscipline = store.getters.getFilterValues(ParameterType.DISCIPLINES)[0];
		return subdisciplineGetParentId(selectedDiscipline) || selectedDiscipline;
	});

	public countryFilterValues = computed((): string[] => {
		return store.getters.getFilterValues(ParameterType.COUNTRY);
	});

	public portalType = computed((): PortalType => {
		return store.getters.getPortalType();
	});

	public mounted(): void {
		EventsSender.initializeRecommendations(this.dataIdentifier);
		EventsSender.subscribeToRecommendationsEvents(this.dataIdentifier);
		this.updateRecommendations();
	}

	private updateRecommendations(): void {
		const data = {
			identifier: this.dataIdentifier,
		};

		if (this.countryFilterValues.value.length > 0) {
			data['countries'] = toRaw(this.countryFilterValues.value);
		}

		if (this.selectedParentDiscipline.value) {
			data['disciplines'] = this.selectedParentDiscipline.value;
		}

		document.dispatchEvent(new CustomEvent('recommendations_update_filters', { detail: data }));
	}
}
